let $playVideo;

$(document).ready(function() {
  let $videos = $('.js-video');

  const containsYoutubePlayerBlock = $('.js-youtube-video').length > 0;

  if (containsYoutubePlayerBlock) {
    addYoutubeAPIScript();
  }

  $videos.each(function() {
    let $playButton = $(this).find('.js-video-play');
    let $videoParent = $(this);
    let youtubePlayer;
    let initYoutubeCheck = false;

    $playButton.on('click', function() {
      let $videoUpload = $($videoParent[0]).find('video');
      let $iframe = $($videoParent[0]).find('iframe');

      if ($videoUpload.length > 0) {
        playHtmlVideotag($videoUpload, $videoParent);
      }

      if (containsYoutubePlayerBlock) {
        if ( !initYoutubeCheck ) {
          youtubePlayer = initYoutube($videoParent);
          initYoutubeCheck = true;

          setTimeout(function() {
            playYoutube(youtubePlayer);
          }, 1000);

        } else {
          playYoutube(youtubePlayer);
        }
      }

      if ($iframe[0] && $iframe[0].src.indexOf("vimeo") >= 0) {
        playVimeo($iframe[0], $videoParent);
      }

      $videoParent.addClass('is-active');
    })
  })

  function initYoutube($videoParent) {
    return new YT.Player($videoParent.data('youtube-container-id'), {
      height: '307',
      width: '544',
      videoId: $videoParent.data('youtube-id'),
      playerVars: {
        'playsinline': 1,
        'origin': window.location.origin
      }
    })
  }
});

function playYoutube(youtubePlayer) {
  youtubePlayer.playVideo();
}

function playVimeo($video, $videoParent) {
  let player;

  $($video).parent().removeClass('d-none');

  if (!$videoParent.hasClass('is-active')) {
    let script = document.createElement( 'script' );
    script.type = 'text/javascript';
    script.src = 'https://player.vimeo.com/api/player.js';
    $(".s-wrapper").after( script );

    setTimeout(function() {
      player = new Vimeo.Player($video);
      player.play();
    }, 500);

    $videoParent.addClass('is-active');
  }

}

function playHtmlVideotag($video, $videoParent) {
  $video[0].play();
  $($video).parent().removeClass('d-none');
  $videoParent.addClass('is-active');
}

function addYoutubeAPIScript() {
  let tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}
